import React from 'react';
import { IInvoiceGroup } from 'src/models/dlcLease/IInvoiceGroup';

interface IProps {
    groups: IInvoiceGroup[];
    currentIndex: number;
    onNavigate: (index: number) => void;
    buttonStyle?: React.CSSProperties;
}

const InvoiceGroupNavigation: React.FC<IProps> = ({ groups, currentIndex, onNavigate, buttonStyle }) => {
    if (groups.length === 0) {
        return null;
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginLeft: 'auto', marginRight: '1rem' }}>
            <button type="button" onClick={() => onNavigate(currentIndex - 1)} disabled={currentIndex === 0} style={buttonStyle}>
                Previous
            </button>
            <select
                aria-label="Invoice Group"
                value={currentIndex}
                onChange={(event) => onNavigate(Number(event.target.value))}
                style={{ minWidth: '170px', padding: '0.5rem', border: '1px solid #D1D5DB', borderRadius: '4px' }}
            >
                {groups.map((invoiceGroup, index) => (
                    <option key={invoiceGroup.groupNo} value={index}>
                        Group #{invoiceGroup.groupNo}
                    </option>
                ))}
            </select>
            <span style={{ whiteSpace: 'nowrap', color: '#6B7280', fontSize: '0.85rem' }}>
                {currentIndex + 1} of {groups.length}
            </span>
            <button type="button" onClick={() => onNavigate(currentIndex + 1)} disabled={currentIndex === groups.length - 1} style={buttonStyle}>
                Next
            </button>
        </div>
    );
};

export default InvoiceGroupNavigation;



// WEBPACK FOOTER //
// ./src/components/leases/sections/InvoiceGroupNavigation.tsx